export default __webpack_public_path__ + "static/media/hht2_ep13_speaking_02.54b0a70e.png";